module.exports = __webpack_public_path__ + "img/huarun.2a8f9582.png";